import { useState } from 'react';
import { gql } from '@apollo/client';
import { useMutation } from 'platform/useMutation';
import {
  ClosePriceAdjustment,
  ClosePriceAdjustmentVariables,
} from 'sellDirect/graphql/__generated__/ClosePriceAdjustment';
import { useQualificationContext } from 'shared/helpers/QualificationContext';
import { useObservability } from 'shared/helpers/observability';

export const ClosePriceAdjustmentCall = gql`
  mutation ClosePriceAdjustment($leadUuid: String!) {
    sellDirect {
      closePriceAdjustment(input: { leadUuid: $leadUuid }) {
        _empty
      }
    }
  }
`;
/** Mutation that triggers once a user has closed the price adjustment modal or price increase prompt */
export const useClosePriceAdjustment = (initialResultOpen: boolean) => {
  const { trackError } = useObservability();
  const { lead } = useQualificationContext();
  const [isResultOpen, setIsResultOpen] = useState(initialResultOpen);

  const [closedPriceAdjustment, { loading, data, error }] = useMutation<
    ClosePriceAdjustment,
    ClosePriceAdjustmentVariables
  >(ClosePriceAdjustmentCall, {
    awaitRefetchQueries: true,
    fetchPolicy: 'no-cache',
    refetchQueries: ['GetPriceAdjustment'],
  });

  const updateClosedPriceAdjustment = () => {
    setIsResultOpen(false);
    if (!lead?.id) {
      trackError('useClosePriceAdjustment called without a lead.id');
      return false;
    }
    closedPriceAdjustment({ variables: { leadUuid: lead.id } });
  };

  return { updateClosedPriceAdjustment, isResultOpen, loading, data, error };
};
